<ng-container *ngIf="hasPermission$ | async; else moduleNotPermitted">
    <h6 class="bxt-table-title">{{ title }} ({{ page.totalElements }})</h6>

    <bx-table-header
        [showCreateNew]="false"
        (searchEvent)="setSearch($event)"
        [searchable]="true"
        [showSettingsActions]="true"
        [moreActions]="moreActions"
        (moreActionEvent)="resolveAction($event)">
        <app-bx-dropdown-generic settings #dropdown [buttonLabel]="'Settings'" [placement]="'right'">
            <div class="group-start">
                <app-bx-dropdown-options [groups]="settingsActions" [type]="'radio'" (select)="selectItem($event)">
                </app-bx-dropdown-options>
            </div>

            <div class="group-end">
                <app-bx-dropdown-options
                    [groups]="simpleItems"
                    [type]="'simple'"
                    (select)="resolveSimpleItemsSettingsAction($event); dropdown.close()">
                </app-bx-dropdown-options>
            </div>
        </app-bx-dropdown-generic>
    </bx-table-header>

    <div class="col-xs-12 text-center empty-table" *ngIf="rows?.length === 0 && !isLoading">
        <h4 class="margin-top-30 margin-bottom-30">You don't have any invoices here yet.</h4>
        <br />
    </div>

    <div class="table-wrapper" #tableWrapper>
        <ngx-datatable
            #myTable
            class="material bxt-table"
            [rowHeight]="40"
            [rows]="rows"
            [columnMode]="'force'"
            [headerHeight]="50"
            [loadingIndicator]="isLoading"
            [footerHeight]="50"
            [externalPaging]="true"
            [count]="page.totalElements"
            [offset]="page.pageNumber"
            [limit]="page.size"
            (page)="setPage($event)"
            [externalSorting]="true"
            (sort)="onSort($event)"
            [scrollbarV]="true"
            [scrollbarH]="layoutService.isMobile()"
            [virtualization]="false"
            [sorts]="[{ prop: sortField, dir: 'desc' }]"
            *ngIf="rows?.length"
            (resize)="onResize()">
            <!-- columns  -->
            <ngx-datatable-column
                name="Invoice #"
                prop="invoiceNumber"
                [cellClass]="'show-pipe'"
                [headerClass]="'show-pipe'"
                [flexGrow]="4"
                [width]="invoicesWidths.invoiceNumber">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <a
                        class="bxt-row-action"
                        title="{{ row.invoiceNumber }}"
                        (click)="viewInvoice(row)"
                        *ngIf="permissionService.isAvailable('jobs.maintain-invoices.view-invoice-details'); else disabledInvNo">
                        <span *ngIf="row.invoiceNumber === 0; else hasNumber">(new)</span></a
                    >
                    <ng-template #disabledInvNo>
                        <span *ngIf="row.invoiceNumber === 0; else hasNumber">(new)</span>
                    </ng-template>
                    <ng-template #hasNumber>{{ row.invoiceNumber }}</ng-template>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Description" prop="description" [flexGrow]="8" [width]="invoicesWidths.description">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <a
                        class="bxt-row-action"
                        title="{{ row.description }}"
                        (click)="viewInvoice(row)"
                        *ngIf="permissionService.isAvailable('jobs.maintain-invoices.view-invoice-details'); else disabledDesc"
                        [title]="row.description">
                        {{ row.description }}</a
                    >
                    <ng-template #disabledDesc
                        ><span [title]="row.description">{{ row.description }}</span></ng-template
                    >
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Job" prop="jobDescription" [flexGrow]="6" [width]="invoicesWidths.jobDescription">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <a
                        *ngIf="permissionService.isAvailable('jobs.maintain-jobs.view-jobs'); else disabledJobDesc"
                        class="bxt-row-action"
                        title="{{ row.job.number }} - {{ row.job.description }}"
                        [routerLink]="['/jobs', 'list', row.iD_Job]">
                        {{ row.job.number }} - {{ row.job.description }}</a
                    >
                    <ng-template #disabledJobDesc>{{ row.job.number }} - {{ row.job.description }}</ng-template>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Client" prop="jobClientName" [flexGrow]="7" [width]="invoicesWidths.jobClientName">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <a
                        *ngIf="permissionService.isAvailable('customers.maintain-customers.customer-details'); else disabledClientDesc"
                        class="bxt-row-action"
                        title="{{ row.job.clientName }}"
                        [routerLink]="['/customers', 'list', row.job.iD_Customer]"
                        [title]="row.job.clientName">
                        {{ row.job.clientName }}</a
                    >
                    <ng-template #disabledClientDesc
                        ><span [title]="row.job.clientName">{{ row.job.clientName }}</span>
                    </ng-template>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Invoiced" prop="invoiceDate" [flexGrow]="5" [width]="invoicesWidths.invoiceDate">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.invoiceDate | date }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Due" prop="dueDate" [flexGrow]="5" [width]="invoicesWidths.dueDate">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.dueDate | date }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
                *ngIf="!taxDisplayStatus"
                name="Total (Ex)"
                prop="totalIncTax"
                [flexGrow]="6"
                [cellClass]="'right-align'"
                [width]="invoicesWidths.totalIncTax">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span [title]="row.total | bxCurrency">{{ row.total | bxCurrency }}</span>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
                *ngIf="taxDisplayStatus"
                name="Total (Inc)"
                prop="totalIncTax"
                [flexGrow]="6"
                [cellClass]="'right-align'"
                [width]="invoicesWidths.totalIncTax">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span [title]="row.totalIncTax | bxCurrency">{{ row.totalIncTax | bxCurrency }}</span>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Status" prop="status" [flexGrow]="6" [width]="invoicesWidths.status">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span
                        class="status-pill"
                        [ngClass]="{
                            new: row.status === 'Pending',
                            blue: row.status === 'PartReceived' || row.status === 'Invoiced',
                            green: row.status === 'Received',
                        }"
                        >{{ row.status }}</span
                    >
                    <span class="sync-status-tick" *ngIf="row.accSyncData && row.accSyncData !== 'blocked'">
                        <i class="icon-ic-tick-s1" title="Synced"></i>
                    </span>
                </ng-template>
            </ngx-datatable-column>

            <!-- Call to action list-->
            <ngx-datatable-column
                [width]="130"
                [sortable]="false"
                [canAutoResize]="false"
                [draggable]="false"
                [resizeable]="false"
                [cellClass]="'right-align'"
                [headerClass]="'disabled'">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <button
                        type="button"
                        class="btn btn-sm btn-info btn-default--narrow margin-right-2"
                        *ngIf="row.status === 'Invoiced' || row.status === 'PartReceived'"
                        (click)="addReceipt(row)"
                        title="Add Payment Receipt">
                        <i class="ti-receipt"></i>
                    </button>
                    <button
                        type="button"
                        class="btn btn-sm btn-default btn-default--narrow margin-right-2"
                        (click)="printInvoice(row)"
                        title="Print">
                        <i class="ti-printer"></i>
                    </button>
                    <button
                        type="button"
                        class="btn btn-sm btn-default btn-default--narrow margin-right-1"
                        *ngIf="isSendInvoiceEmailVisible"
                        (click)="emailInvoice(row)"
                        title="Email">
                        <i class="ti-email"></i>
                    </button>
                    <button
                        type="button"
                        class="btn btn-sm btn-danger btn-default--narrow margin-right-1"
                        [disabled]="row.status !== 'Pending'"
                        (click)="deleteInvoice($event, row)"
                        title="Delete">
                        <i class="ti-trash"></i>
                    </button>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-footer>
                <ng-template
                    ngx-datatable-footer-template
                    let-rowCount="rowCount"
                    let-pageSize="pageSize"
                    let-selectedCount="selectedCount"
                    let-curPage="curPage"
                    let-offset="offset"
                    let-isVisible="isVisible">
                    <app-table-footer-paging *ngIf="rowCount > 10" [size]="page.size" (pageLimitChange)="pageLimit($event)">
                    </app-table-footer-paging>

                    <datatable-pager
                        [pagerLeftArrowIcon]="'datatable-icon-left'"
                        [pagerRightArrowIcon]="'datatable-icon-right'"
                        [pagerPreviousIcon]="'datatable-icon-prev'"
                        [pagerNextIcon]="'datatable-icon-skip'"
                        [page]="curPage"
                        [size]="pageSize"
                        [count]="rowCount"
                        [hidden]="!(rowCount / pageSize > 1)"
                        (change)="table.onFooterPage($event)">
                    </datatable-pager>
                </ng-template>
            </ngx-datatable-footer>
        </ngx-datatable>
    </div>
</ng-container>

<ng-template #moduleNotPermitted>
    <app-bx-permission-notification></app-bx-permission-notification>
</ng-template>
